import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { BindAccountPage } from "./bind-account";

@NgModule({
  declarations: [BindAccountPage],
  imports: [IonicPageModule.forChild(BindAccountPage)],
})
export class BindAccountPageModule {}



// WEBPACK FOOTER //
// ./src/pages/bind-account/bind-account.module.ts